export enum RentFrequencyEnum {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  ANNUALLY = "annually",
  FOUR_WEEKLY = "fourWeekly",
}
